<template>
    <div>
        <v-col cols="12" class="tabs">
            <h2 class="mt-4">{{ t('astm-devices::page.title.astm_devices') }}</h2>

            <v-tabs v-model="tab" show-arrows>
                <v-tab v-for="(item, index) in items" :key="item">
                    <div class="tab">
                        {{ item }}
                        <v-avatar
                            v-if="pendingCount && index === 1"
                            color="notifications"
                            size="20"
                            class="absolute-top-left ml-3"
                        >
                            <span class="white--text" style="font-size: 10px; position: relative">{{
                                pendingCount
                            }}</span>
                        </v-avatar>
                    </div>
                </v-tab>
                <v-tab-item v-for="(item, index) in items" :key="item + index">
                    <astm-device-data-table
                        ref="grid"
                        :initial-filters="initialFilters"
                        :columns="columns"
                        :hidden-columns="hiddenColumns"
                        :list-route="listRoute"
                        :grid-title="item"
                    >
                    </astm-device-data-table>
                </v-tab-item>
            </v-tabs>
        </v-col>
    </div>
</template>

<script>
export default {
    name: 'AstmDeviceIndexComponent',
    props: {
        listRoute: {
            type: String,
            required: true,
        },
    },
    data() {
        return {
            tab: null,
            items: [t('astm-devices::label.authorised'), t('astm-devices::label.pending_authorisation')],
            initialFilters: {
                active: null,
            },
            columnsList: {
                authorizedColumns: [
                    {
                        text: t('astm-devices::grid.label.id'),
                        value: 'id',
                        sortable: false,
                    },

                    {
                        text: t('astm-devices::grid.label.analyzer_name'),
                        value: 'analyzer_name',
                        sortable: false,
                    },

                    {
                        text: t('astm-devices::grid.label.device_id'),
                        value: 'name',
                        sortable: true,
                    },
                    {
                        text: null,
                        value: 'is_patient_mode',
                        sortable: false,
                        class: 'is_patient_mode',
                        cellClass: 'is_patient_mode',
                        width: 0,
                    },
                    {
                        text: t('quality-control::grid.label.device_type'),
                        value: 'device',
                        sortable: true,
                        width: 140,
                    },
                    {
                        text: 'neqas overdue',
                        value: 'neqas_overdue',
                    },
                    {
                        text: t('astm-devices::grid.label.prn'),
                        value: 'prn',
                        sortable: true,
                        width: 140,
                    },
                    {
                        text: t('astm-devices::grid.label.pharmacy_site'),
                        value: 'pharmacy_site.site_name',
                        sortable: true,
                    },
                    {
                        text: t('astm-devices::grid.label.status'),
                        value: 'active',
                        sortable: true,
                        width: 140,
                    },
                    {
                        text: t('astm-devices::grid.label.openvpn-status'),
                        value: 'open_vpn_status',
                        sortable: true,
                        width: 140,
                    },
                    {
                        text: t('reports::grid.label.actions'),
                        value: 'actions',
                        sortable: false,
                        fields: 'is_patient_mode,visible_in_qc_list',
                        align: 'end',
                        width: 140,
                    },
                ],
                unAuthorizedColumns: [
                    {
                        text: t('default::grid.label.id'),
                        value: 'id',
                        sortable: false,
                    },
                    {
                        text: t('astm-devices::grid.label.device_id'),
                        value: 'name',
                        sortable: true,
                    },
                    {
                        text: t('astm-devices::grid.label.date_of_last_connection_attempt'),
                        value: 'last_active_at',
                        sortable: true,
                    },
                    {
                        text: t('astm-devices::grid.label.actions'),
                        value: 'actions',
                        sortable: false,
                        fields: null,
                        width: 140,
                        align: 'end',
                    },
                ],
            },
            hiddenColumnsList: {
                authorizedColumns: ['id', 'analyzer_name', 'neqas_overdue'],
                unAuthorizedColumns: ['id'],
            },
            hiddenColumns: [],
            columns: [],
            pendingCount: false,
        };
    },
    watch: {
        tab: function (val) {
            this.$store.dispatch('data_table/changeTab', val);
            if (val === 1) {
                this.columns = this.columnsList.unAuthorizedColumns;
                this.hiddenColumns = this.hiddenColumnsList.unAuthorizedColumns;
                this.initialFilters.authorized = 0;
            } else {
                this.columns = this.columnsList.authorizedColumns;
                this.hiddenColumns = this.hiddenColumnsList.authorizedColumns;
                this.initialFilters.authorized = 1;
            }
            _.delay(() => {
                window.dispatchEvent(new Event('scroll'));
                if (this.$refs.grid[val]) {
                    this.$refs.grid[val].changeTab();
                }
            }, 200);
        },
    },
    created() {
        this.columns = !this.tab ? this.columnsList.authorizedColumns : this.columnsList.unAuthorizedColumns;
        const urlParams = new URLSearchParams(window.location.search);
        for (const key of urlParams.keys()) {
            this.initialFilters[key] = urlParams.get(key);
        }
    },
    mounted() {
        axios
            .get(
                route('api.v1.astm-devices.index', {
                    authorized: 0,
                    fields: 'id',
                    limit: -1,
                })
            )
            .then((response) => {
                this.pendingCount = response.data.data ? response.data.data.length : false;
            });
    },
};
</script>
